import { isEmpty } from "@utils/var.check";

export default {
  data() {
    return {
      switchingView: false,
      refreshIntervalId: null,
      urlReady: null,
      urlReadyAndCloseModal: false,
      target: "_blank",
    };
  },
  methods: {
    pushRoute(pushFunc) {
      if (this.switchingView) {
        return;
      }
      this.switchingView = true;
      return pushFunc().finally(() => (this.switchingView = false));
    },
    handleRouteIntervalCheck() {
      this.urlReadyAndCloseModal = false;
      this.urlReady = null;
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = setInterval(() => {
        if (!isNull(this.urlReady)) {
          if (!isEmpty(this.target)) {
            console.log("opening new tab with target " + this.urlReady);
            window.open(this.urlReady, this.target);
            if (this.urlReadyAndCloseModal) {
              this.urlReadyAndCloseModal = false;
              this.$modal.removeAll();
            }
          } else {
            console.log("opening new tab " + this.urlReady);
            window.open(this.urlReady);
            if (this.urlReadyAndCloseModal) {
              this.urlReadyAndCloseModal = false;
              this.$modal.removeAll();
            }
          }
          clearInterval(this.refreshIntervalId);
        }
      }, 500);
    },
  },
};
